/**
 * Enum representing the fields by which assessment forms can be ordered.
 */
export enum AssessmentFormRawOrderField {
  StatusRank = 'statusRank',
  SubmittedAt = 'submittedAt',
  Title = 'title',
}
